/* eslint-disable no-unsafe-optional-chaining */
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import { estimateSelector } from '../../redux'

import Land from './Land'

const EstimateLandSummary = () => {
  const estimate = useSelector(estimateSelector)

  const lands = estimate?.lands || []

  return (
    <Box>
      {lands?.map((land: any, index: number) => {
        let editedLand: any
        const landId = land?.land_id

        if (estimate?.editedLands && landId in estimate?.editedLands) {
          editedLand = estimate?.editedLands[landId]
        }

        return <Land key={index} land={land} editedLand={editedLand} />
      })}
    </Box>
  )
}

export default EstimateLandSummary
